module.exports = __webpack_public_path__ + "img/Portugal.ec536776.svg";